import React, { useState } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import DownloadIcon from '@mui/icons-material/Download';
import {
  Container,
  Typography,
  Grid,
  Card,
  Button,
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  styled,
  createTheme,
  ThemeProvider,
  Box,
  CardMedia,
} from '@mui/material';
import moment from 'moment';
import Footer from '../navbar/Footer';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const bulletinsStatistiquesData = [
   {
    title: "Bulletin d’information :  Premier Trimestre 2025",
    description: "Le NewsStat du 1ᵉ trimestre 2025 met en lumière les avancées institutionnelles et statistiques majeures, dont la publication des résultats préliminaires du RGPHAE 2024, des ateliers de renforcement des capacités, l’analyse de l’inflation, ainsi que la participation active aux instances nationales et internationales.",
    link: "/documents/NewsStats/NEWSSTAT_MARS_FIN.pdf",
    date: "2025-03-01",
    image: 'assets/Bulletins/newsStat.PNG',
  },

   {
    title: "Bulletin d’information : Troisieme Trimestre 2024",
    description: "Le NewsStat du troisième trimestre 2024 met en lumière les principales initiatives et réalisations de l'Institut de Statistiques du Burundi. Ce numéro couvre des événements stratégiques tels que l’Atelier national sur le Système de Comptabilité Économique et Environnementale (SCEE), ainsi que les ateliers régionaux dédiés à la dissémination des indicateurs de suivi de la Vision Burundi 2040-2060, du PND révisé et des Objectifs de Développement Durable (ODD). Il propose également une analyse de l’inflation moyenne annuelle et revient sur les temps forts du 13ème Mois de la Statistique au Burundi (MSB) et de la Journée Africaine de la Statistique (JAS). Enfin, il souligne le lancement officiel du projet de financement additionnel pour le programme régional de statistiques de la Communauté Est-Africaine, marquant un engagement renforcé en faveur du développement des capacités statistiques.",
    link: "/documents/NewsStats/NEWSSTAT_DECEMBRE_FIN.pdf",
    date: "2024-12-01",
    image: 'assets/Bulletins/newsStat.PNG',
  },
  {
    title: "Bulletin d’information : Deuxième Trimestre 2024",
    description: "La présentation des actions pour promouvoir la culture statistique, incluant la 31ème Journée Africaine de la Statistique et des ateliers de renforcement des capacités.",
    link: "/documents/NewsStats/NewsStat_Trimestre-2_VF_Fevrier_2024.pdf",
    date: "2023-12-01",
    image: 'assets/Bulletins/newsStat.PNG',
  },
  {
    title: "Bulletin d’information : Premier Trimestre 2024",
    description: "La mise en avant des activités d'appui technique, réunions et ateliers, ainsi que les indices des prix à la consommation des ménages et du commerce extérieur.",
    link: "/documents/NewsStats/NEWSSTAT-BOUCLE_VF_13.11.2023_A-Imprimer-1-1.pdf",
    date: "2023-11-01",
     image: 'assets/Bulletins/newsStat.PNG',
  },
  {
    title: "Bulletin d’information : Deuxième Trimestre de l’année 2017",
    description: "La mise en lumière des réalisations statistiques du 2ème trimestre 2017, ainsi que l’implication de l’ISTEEBU dans le paysage statistique régional. Il présente des indicateurs macroéconomiques et des résultats de la troisième enquête démographique et de santé.",
    link: "/documents/NewsStats/NEWSSTAT-B-N.2-B1-Vrai-au-16.08.2017.pdf", 
    date: "2017-08-01",
     image: 'assets/Bulletins/newsStat.PNG',
  },
  {
    title: "Bulletin d’information : Premier Trimestre de l’année 2017",
    description: "L'information sur les activités du Système Statistique National (SSN) et souligne les réalisations et plans de l'ISTEEBU pour 2017, incluant le premier rapport sur le financement des activités statistiques.",
    link: "/documents/NewsStats/NewsStat-Burundi-N0-1-avril.pdf", 
    date: "2017-04-01",
     image: 'assets/Bulletins/newsStat.PNG',
  },
  {
    title: 'Recueil des concepts, définitions, nomenclatures et méthodologies utilisées dans le système statistique national du Burundi',
    link: '/documents/Bulletins/Recueil-.pdf',
    date: new Date('2024-11-01'),
    description: "La présentation de nouveaux concepts et méthodologies.",
    image: 'assets/Bulletins/receuil.PNG',
  },
  {
    title: 'NewsStat Burundi N°3',
    link: '/documents/Bulletins/NEWSSTAT-BOUCLE_VF_213.11.pdf',
    date: new Date('2023-09-01'),
    description: "La présention des activités du premier trimestre 2023-2024, incluant des visites d'appui technique et les indices des prix à la consommation des ménages.",
    image: 'assets/Bulletins/newsStat.PNG',
  },
  {
    title: 'NewsStat Burundi N°2',
    link: '/documents/Bulletins/NEWSSTAT-B-N.2-B1-Vrai-au-16.08.2017.pdf',
    date: new Date('2017-08-16'),
    description: "La concentration sur les réalisations statistiques du 2ème trimestre 2017 et présente des indicateurs clés, ainsi que des données de la troisième enquête démographique et de santé.",
    image: 'assets/Bulletins/newstat2_2017.PNG',
  },
  {
    title: 'NewsStat Burundi N°1',
    link: '/documents/Bulletins/NewsStat-Burundi-N0-1.pdf',
    date: new Date('2017-02-01'),
    description: "L'information sur les activités du SSN et les initiatives de l'ISTEEBU pour améliorer la visibilité et la satisfaction des utilisateurs de données.",
     image: 'assets/Bulletins/newsStat.PNG',
  },
];




const theme = createTheme({
  palette: {
    primary: {
      main: '#388E3C',
    },
    secondary: {
      main: '#673AB7',
    },
    background: {
      default: '#f5f5f5',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h6: {
      fontWeight: '500',
      fontSize: '1rem',
      textTransform: 'none',
      color: '#3B3F54'
    },
    body2: {
      fontSize: 14,
      letterSpacing: 0.25,
      color: '#6B778C',
    },
    body1: {
      fontSize: 16,
      letterSpacing: 0.5,
      color: '#6B778C',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
          textTransform: 'none',
          fontWeight: '500',
          padding: '10px 20px',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
          '&:hover': {
            transform: 'scale(1.05)',
            boxShadow: '0px 12px 20px rgba(0, 0, 0, 0.15)',
          },
          borderRadius: '16px',
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        h6: {
          fontWeight: '500',
          fontSize: '1rem',
        },
        h4: {
          fontWeight: '600',
        },
      },
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          marginBottom: '16px',
        },
      },
    },
  },
});

function BulletinsStatistiques() {
  const [visibleCount, setVisibleCount] = useState(4);
  const [selectedYear, setSelectedYear] = useState('Tous');
  const navigate = useNavigate();
  const [filteredBulletins, setFilteredBulletins] = useState(bulletinsStatistiquesData);

  const handleShowMore = () => {
    setVisibleCount((prevCount) => prevCount + 2);
  };

  const handleYearChange = (event) => {
    const year = event.target.value;
    setSelectedYear(year);

    if (year === 'Tous') {
      setFilteredBulletins(bulletinsStatistiquesData);
    } else {
      const filtered = bulletinsStatistiquesData.filter((bulletin) => {
        const bulletinYear = new Date(bulletin.date).getFullYear();
        return bulletinYear === parseInt(year);
      });
      setFilteredBulletins(filtered);
    }
  };

  const StyledSelect = styled(Select)(({ theme }) => ({
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.main,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.light,
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.dark,
    },
  }));

  return (
    <ThemeProvider theme={theme}>
            <div style={{ backgroundColor: theme.palette.background.default, paddingBottom: '32px' }}>
        <NavigationBar />
         <br />
        <br />
        <Container maxWidth="lg" style={{ paddingTop: '54px' }}>
          <Typography variant="h4" align="justify" gutterBottom style={{ color: theme.palette.primary.main, marginBottom: '16px' }}>
            Bulletins d'Information Statistique de l'INSBU
          </Typography>
          <Divider style={{ margin: '16px 0' }} />
       


            <Typography variant="body1" align="justify" paragraph style={{ marginBottom: '24px' }}>
                Cette section présente des Bulletins d'Information Statistique de l'INSBU, offrant une analyse trimestrielle de la situation économique et sociale du Burundi, avec des données sur les événements clés et des initiatives pour renforcer la culture statistique.
             </Typography>

          <FormControl fullWidth variant="outlined" style={{ marginLeft: '0px', width: '300px' }}>
            <InputLabel id="year-select-label">Sélectionnez par l'année de publication</InputLabel>
            <StyledSelect
              labelId="year-select-label"
              id="year-select"
              value={selectedYear}
              onChange={handleYearChange}
              label="Sélectionnez par l'année de publication"
            >
              <MenuItem value="Tous">Tous les bulletins</MenuItem>
              {[...new Set(bulletinsStatistiquesData.map((bulletin) => new Date(bulletin.date).getFullYear()))]
                .sort((a, b) => b - a) 
                .map((year) => (
                  <MenuItem key={year} value={year.toString()}>
                    {year}
                  </MenuItem>
                ))}
            </StyledSelect>
          </FormControl>

          {/* Affichage des bulletins */}
          <Grid container spacing={1} style={{ marginTop: '10px' }}>
            {filteredBulletins.slice(0, visibleCount).map((bulletin, index) => (
              <Grid item xs={12} sm={6} md={12} key={index}>
                <Card elevation={3} style={{ borderRadius: '12px', overflow: 'hidden', display: 'flex', flexDirection: 'column', height: '100%' }}>
                  <Box sx={{ display: 'flex' }}>
                    <CardMedia
                      component="img"
                      sx={{ width: 71, height: 100, m: 2, cursor: 'pointer' }}
                      image={bulletin.image}
                      alt={bulletin.title}
                      onClick={() => window.open(bulletin.link, '_blank')}
                    />
                    <Box sx={{ display: 'flex', flexDirection: 'column', pl: 2, pt: 2 }}>
                      <Typography variant="h6" component="div" style={{ fontWeight: 'bold', marginBottom: '10px', color: theme.palette.primary.main }}>
                        <a
                          href={bulletin.link}
                          style={{ textDecoration: 'none', color: 'inherit' }}
                          rel="noopener noreferrer"
                          target="_blank"
                        >
                          {<DownloadIcon />}{bulletin.title}
                        </a>
                      </Typography>
                      <Typography variant="body2" component="div" style={{ color: '#555', marginBottom: '10px' }}>
                        {bulletin.description}
                      </Typography>
                      <Typography variant="caption" color="textSecondary">
                      Publié en {moment(bulletin.date).format('MMMM YYYY')}
                      </Typography>
                    </Box>
                  </Box>
                </Card>
              </Grid>
            ))}
          </Grid>

          {visibleCount < filteredBulletins.length && (
            <Button
              onClick={handleShowMore}
              style={{
                marginTop: '20px',
                backgroundColor: theme.palette.primary.main,
                color: 'white',
              }}
            >
              Plus de Bulletins
            </Button>
          )}
          <br />
          <br />
          <Typography
            variant="body1"
            align="justify"
            paragraph
            style={{ marginBottom: '24px', lineHeight: 1.6 }}
          >
            <strong>Note :</strong> Les <strong>Bulletins d'Information Statistique de l'INSBU</strong> sont publiés trimestriellement, généralement <strong>45 jours</strong> après la clôture de chaque trimestre. Les dates prévues pour la publication de ces bulletins sont les suivantes :
            <ul style={{ listStyleType: 'circle', margin: '10px 0 10px 20px', padding: 0 }}>
              <li><strong>15 février</strong> - Publication des données pour le quatrième trimestre de l'année précédente</li>
              <li><strong>15 mai</strong> - Publication des données pour le premier trimestre de l'année en cours</li>
              <li><strong>15 août</strong> - Publication des données pour le deuxième trimestre de l'année en cours</li>
              <li><strong>15 novembre</strong> - Publication des données pour le troisième trimestre de l'année en cours</li>
            </ul>
          </Typography>

          <Box display="flex" justifyContent="flex-start" alignItems="center">
            <Button
              onClick={() => navigate('/bulletin')}
              style={{
                marginTop: '5px',
                backgroundColor: '#388E3C',
                color: 'white',
              }}
            >
              <ArrowBackIcon style={{ marginRight: '8px' }} />
              Retour à la page des bulletins 
            </Button>
          </Box>
        </Container>
        <br />
        <br />
        <Footer />
      </div>
    </ThemeProvider>
  );
}

export default BulletinsStatistiques;